import React, {
    useState,
    useRef,
    useCallback,
    useContext,
} from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import PatientInformation from 'src/pages/reportUsage/common/patientInformation/PatientInformation';
// import AddItemSearchItem from '../addSearchItems/AddItemSearchItem';
import AddItemSearchItem from 'src/common/refactoredComponents/addItemSearchItem/AddItemSearchItem';
import { localData } from '../../components/addSearchItems/LocalJsonData';
import { AddAndSearchItemContainer } from '../addSearchItems/AddItemSearchItem.styled';
import { searchProducts } from 'src/pages/scheduleSurgery/redux/actions';
import PriceItemButton from 'src/pages/reportUsage/record/components/priceItems/priceItemButton';
import {
    validateReportPaymentItem,
    toggleSaveExitButton,
    checkIfValidPricedRPItems,
    hasSplitRowQtyError,
    priceOverrideData,
    isPriceOverrideApplyBtnDisabled,
    getModifiedButtonVisibilities,
    displayCheckbox,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import ItemListRPView from 'src/pages/reportUsage/record/components/reportPayment/ItemList/ItemListRPView.jsx';
import { ReportUsageContext } from 'src/pages/reportUsage';
import ReportPaymentDesktop from '../reportPaymentTable/reportPaymentTableDesktop';
import { useTranslation } from 'react-i18next';
import AddPo from './AddPo/AddPo';
import Summary from 'src/common/components/summary';
import { sizes } from 'src/styles/Media.styled';
import axios from 'src/api/Api';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import { SET_ITEMS_DURING_PRICING } from 'src/pages/reportUsage/redux/action/types';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';
import AddPoButton from '../addPoButton';
import {
    clearValidateReplenData,
    getDropdownOptionsRequest,
    storeUsageDataPresist,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { ErrorMsgContainer } from '../itemsList/LotSerialQtyInput';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import {
    emptyBundleMsg,
    getItemTableDataWithQtyValidation,
    getPriceInNumberDataType,
    noPriceErrorMsg,
    productIssueErrMsg,
    isFeeItemInGatewayOrder,
    invalidSPSitemMsg,
    isProductCfnInList,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import PriceOverrideButtonContainer from '../priceOverride/priceOverrideButtonContainer';
import PriceOverride from '../priceOverride';
import BundleAddItemSearchItem from '../addSearchItems/BundleAddItemSearchItem';
import { hideScrolling, resumeScrolling, logErrorToConsole, getArrayItem } from 'src/utils/util';
import ReviewContainer from 'src/pages/reportUsage/review/view';
import ReplenViewContainer from 'src/pages/reportUsage/replen/view';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import {
    resetBarcodeDetails,
    successMessageCamera,
} from 'src/common/barCodeScannerRedux/actions/actionCreators';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ReportPayment = ({
    reportPaymentGridData,
    setReportPaymentGridData,
    checkboxReportPaymentClickHandler,
    headerReportPaymentCheckboxClickHandler,
    allSelected,
    setAllSelected,
    selectedCheckBox,
    checkBoxSelectedIndex,
    onPoApplyClick,
    enablePObutton,
    removeAllPo, // to remove all po from list
    deletePO, // to remove single po from list
    setSelectedCheckBox,
    showRemovePOText,
    myCaseResourceType,
    rpInitialLoad,
    setRpInitialLoad,
    vendorCaseErrorRedirection,
    onFlagChange,
    isPriceOverride,
    setPriceOverride,
    isRPPriceOverride,
    setRPPriceOverride,
    setRPPriceOverrideData,
    priceOverrideReason,
    setPriceOverrideReason,
    setShipAddress,
    shipAddress,
    navigateToSpecifiedRPScreen,
    pricingNotes,
    setPricingNotes,
    showReportPayment,
    countryCode,
    priceOverrideReportUsageVisibility,
    setIsReportPaymentScreen,
    currentActivity,
    setViewSurgeryNotes,
    priceOverrideReasonMandatoryUsage,  
    priceOverrideReasonVisibilityUsage ,                              
    priceOverrideCommentsMandatoryUsage,
    priceOverrideCommentsVisibilityUsage
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isSelected, setselected] = useState(t('reportUsage.addItems.title'));
    const [open, setOpen] = useState(false);
    const [addedChildProduct, setAddedChildProduct] = useState('');
    const [selectedChildProduct, setSelectedChildProduct] = useState('');
    const [addedProduct, setAddedProduct] = useState({});
    const [checkNewAddedProduct, setCheckNewAddedProduct] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [showHidePricesBtn, setShowHidePricesBtn] = useState(false);
    const [toggleHidePricesBtn, setToggleHidePricesBtn] = useState('hideBtn');
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [addItemSearchItem,setAddItemSearchItem] = useState(false);
    // const [priceOverrideReason, setPriceOverrideReason] = useState('');
    // const [isRPPriceOverride, setRPPriceOverride] = useState(false);
    const [axiosSource, setAxiosSource] = useState(axios.CancelToken.source());
    const [successMessage, setSuccessMessage] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    const [bundleError, setBundleError] = useState(false);
    const [productDeleteWarning, setProductDeleteWarning] = useState(false);
    const [deleteItemDetails, setDeleteItemDetails] = useState(null);
    const [priceOverrideTableData, setPriceOverrideTableData] = useState(
        reportPaymentGridData
    );
    const [showBundleModal, setShowBundleModal] = useState({ show: false });
    const {
        setFooterButtonStatuses,
        footerButtonStatuses,
        reportUsageFormObj,
        replenRPGridData,
        setReplenRPGridData,
    } = useContext(ReportUsageContext);

    const { overrideReasons } = useSelector((state) => ({
        overrideReasons:
            state.reportUsageRootReducer.dropdownData.priceoverridereasons &&
            state.reportUsageRootReducer.dropdownData.priceoverridereasons
                .overrideReasons,
    }));
    // const countryCode = useSelector(
    //     (state) => state.loginReducer.hybrisUserDetails.countryCode
    // );
    const usageDetails = useContext(ReportUsageContext)?.usageDetails;
    const bundleHeadersArr =
        usageDetails?.bundleHeaders && usageDetails?.bundleHeaders.split(',');
    const unidId = usageDetails?.unidId;

    const winWidth = window.innerWidth;
    const onOpenModal = () => {
        setShowPopup(true);
    };
    useDynatracePageName(pageNames.reportUsageReportPayment);

    const optionValue = 'description';
    const saveAndExit = t('reportUsage.saveExit');
    const { itemTable } = useSelector((state) => ({
        itemTable: state.reportUsageRootReducer.itemTableData,
    }));
    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer?.usageOrderSubmission
    );
    const reportPaymentFlag = useSelector(
        (state) => state.reportUsageRootReducer.reportPaymentFlag
    );
    const accountOwnedItems =
        reportUsageFormObj.products?.length > 0
            ? reportUsageFormObj.products
                  .filter((item) => item.isAccountOwned || item.accountOwned)
                  .map((item) => {
                      return {
                          ...item,
                          cfn: item.productCFN,
                      };
                  })
            : [];

    const [filteredProduct, setFilteredProduct] = useState(
        itemTable && Array.isArray(itemTable) ? itemTable : []
    );

    const { productsList, productListLoading } = useSelector(
        (state) => ({
            productsList: state.productsSearchReducer.isBulkUpload
                ? []
                : unidId || myCaseResourceType === 'reportPayment'
                ? state.productsSearchReducer.products
                : state?.productsSearchReducer?.products?.filter(
                      (item) => !(item.ph2 && item.ph2.includes('H52'))
                  ),
            productListLoading: state.productsSearchReducer.loading,
        }),
        shallowEqual
    );
    const itemsToBePriced = useSelector(
        (state) => state.reportUsageRootReducer.itemsToBePriced
    );

    const { isPricingDone, reportPaymentScreenName } = useSelector(
        (state) => state.reportUsageRootReducer
    );

    const onSearchAddPress = (dt) => {
        setBundleError(false);
        setSuccessMessage(false);
        setselected(dt);
    };

    const cancelSearchRequest = () => {
        axiosSource?.cancel(t('consignmentReturn.billing.requestCancelled'));
        setAxiosSource(axios.CancelToken.source());
    };

    const addChildProduct = (index) => {
        setAddedChildProduct(index);
    };

    const showBundlefromTableList = (open, index, cfn, unqId) => {
        setAddItemSearchItem('');
        setShowBundleModal({ show: open, index: index, cfn: cfn, unqId: unqId });
    };

    const searchedChildProduct = (index) => {
        setSelectedChildProduct(index);
    };

    const closeBundle = (val) => {
        setShowBundleModal(val);
        setShowBundleModal({ ...showBundleModal, show: val });
        setAddItemSearchItem('');
    };

    useEffectWithErrorLogging(() => {
        if (showBundleModal.show) {
            hideScrolling();
        } else {
            resumeScrolling();
        }
    }, [showBundleModal]);
    useEffectWithErrorLogging(() => {
        setIsReportPaymentScreen(true);
        return () => {
            setIsReportPaymentScreen(false);
        };
    }, [setIsReportPaymentScreen]);
   
    useEffectWithErrorLogging(() => {
        // A priced split row with no qty (used/other still 0) must keep
        // Price Override / Next disabled while its "Qty Required!" error shows.
        const hasSplitQtyError = hasSplitRowQtyError(reportPaymentGridData);
        if (
            !hasSplitQtyError &&
            ((isPricingDone &&
                reportPaymentGridData.every(
                    (item) =>
                        !item.isInvalidItemMsg &&
                        !item.isInvalidQtyMsg &&
                        (item?.lotSerialUnknownApplicable
                            ? item?.lotSerialUnknown
                            : true) &&
                        (item.isBundleItem
                            ? item.bundleItem?.length > 0 &&
                              item.bundleItem.every(
                                  (child) =>
                                      !child.isInvalidItemMsg &&
                                      !child.isInvalidQtyMsg
                              )
                            : true) &&
                        (Object.prototype.hasOwnProperty.call(
                            item,
                            'noItemInBundleErr'
                        )
                            ? !item.noItemInBundleErr
                            : true)
                )) ||
                checkIfValidPricedRPItems(reportPaymentGridData))
        ) {
            setIsButtonDisabled(false);
            setAddedProduct({});
            setSelectedProduct({});
            // dispatch(resetValidatedData());
            // dispatch({ type: SET_ITEMS_DURING_PRICING, payload: [] });
            // dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
        } else {
            setIsButtonDisabled(true);
        }
    }, [isPricingDone, reportPaymentGridData]);

    const priceOverrideClickHandler = () => {
        let modifiedButtonStatuses = [...footerButtonStatuses];
        if (checkIfValidPricedRPItems(reportPaymentGridData)) {
            const data = priceOverrideData(
                reportPaymentGridData.filter((item) => {
                    const activeUnitPrice =
                        item.overrideUnitPrice !== undefined &&
                        item.overrideUnitPrice !== null &&
                        item.overrideUnitPrice !== ''
                            ? item.overrideUnitPrice
                            : item.unitPrice;
                    return item.isDeleteButtonPresent === false &&
                        !item.isAdditionalCartEntry
                        ? false
                        : item.salesOrg != '' && item.salesOrg && activeUnitPrice
                        ? true
                        : false;
                })
            );
            setPriceOverrideTableData(data);
            setRPPriceOverrideData(data);
            setRPPriceOverride(true);
            setPriceOverride(true);
            modifiedButtonStatuses = getModifiedButtonVisibilities(
                myCaseResourceType,
                footerButtonStatuses,
                t('scheduleSurgery.surgery.SurgeryFooter.nextBtn'),
                t('orders.orderListFilters.applyButton')
            );
            setFooterButtonStatuses(modifiedButtonStatuses);
        } else {
            setIsButtonDisabled(true);
            const modifiedItemTableData =
                reportPaymentGridData &&
                reportPaymentGridData.length > 0 &&
                getItemTableDataWithQtyValidation(
                    reportPaymentGridData,
                    myCaseResourceType
                );
            setReportPaymentGridData(modifiedItemTableData);
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
        }
    };

    //delete item

    const deleteItem = () => {
        const { itemIndex, bundleIndex, item , lotItem } = deleteItemDetails;

        // If lotItem exists with an id and item has multiple lotSerial entries, 
        // only remove that specific lotSerial
        if (lotItem?.id && item?.lotSerial?.length > 1) {
            const updatedGridData = [...reportPaymentGridData];
            const targetItem = bundleIndex != undefined 
                ? updatedGridData[bundleIndex].bundleItem[itemIndex]
                : updatedGridData[itemIndex];
            
            // Filter out the specific lotSerial by id
            targetItem.lotSerial = targetItem.lotSerial.filter(
                (ls) => ls.id !== lotItem.id
            );

            setSelectedCheckBox(
                updatedGridData.filter((item) => item.isSelected && item.salesOrg != '')
            );
            setReportPaymentGridData(updatedGridData);
            if (updatedGridData.every((item) => !item.overrideUnitPrice)) {
                setPriceOverrideReason('');
                setPricingNotes('');
            }
        } else {
            // Delete the entire item (existing logic)
        const updatedList =
            bundleIndex != undefined
                ? [...reportPaymentGridData][bundleIndex].bundleItem
                : [...reportPaymentGridData];

        updatedList.splice(itemIndex, 1);
        if (bundleIndex != undefined) {
            const temp = [...reportPaymentGridData];
            temp[bundleIndex].bundleItem = updatedList;
            if (temp[bundleIndex].basePrice && updatedList?.length === 0) {
                temp[bundleIndex].noItemInBundleErr = emptyBundleMsg();
            }
            // setFilteredProduct(temp);
            setSelectedCheckBox(
                temp.filter((item) => item.isSelected && item.salesOrg != '')
            );
            setReportPaymentGridData(temp);
            if (temp.every((item) => !item.overrideUnitPrice)) {
                setPriceOverrideReason('');
                setPricingNotes('');
            }
        } else {
            setSelectedCheckBox(
                updatedList.filter(
                    (item) => item.isSelected && item.salesOrg != ''
                )
            );
            setReportPaymentGridData(updatedList);
            if (updatedList.every((item) => !item.overrideUnitPrice)) {
                setPriceOverrideReason('');
                setPricingNotes('');
            }
            // setFilteredProduct(updatedList);
        }
    }
        setProductDeleteWarning(false);
        setDeleteItemDetails(null);
        if (!item.isAdditionalCartEntry) {
            setRpInitialLoad(true);
        }
        
        // Clear duplicate serial errors that are no longer valid after deletion
        setTimeout(() => {
            setReportPaymentGridData((prevData) => {
                const data = [...prevData];
                const hasDuplicate = (serial, productCFN, excludeIdx) => 
                    serial && data.some((o, i) => i !== excludeIdx && o.productCFN === productCFN &&
                        (o.lotSerialNumber === serial || o.lotSerial?.some((ls) => ls.Serial === serial)));
                
                data.forEach((item, idx) => {
                    const lotSerialItem = getArrayItem(item.lotSerial);
                    if (item.isInvalidLotSerialMsg === productIssueErrMsg && 
                        !hasDuplicate(item.lotSerialNumber || lotSerialItem?.Serial, item.productCFN, idx)) {
                        item.isInvalidLotSerialMsg = null;
                        if (lotSerialItem) lotSerialItem.isInvalidLotSerialMsg = null;
                    }
                    item.lotSerial?.forEach((ls) => {
                        if (ls.isInvalidLotSerialMsg === productIssueErrMsg && !hasDuplicate(ls.Serial, item.productCFN, idx))
                            ls.isInvalidLotSerialMsg = null;
                    });
                });
                return data;
            });
        }, 0);
        if (
            itemsToBePriced &&
            itemsToBePriced.length > 0 &&
            itemsToBePriced.includes(item.cfn || item.productCFN)
        ) {
            dispatch({
                type: SET_ITEMS_DURING_PRICING,
                payload: itemsToBePriced.filter(
                    (x) => x !== (item.cfn || item.productCFN)
                ),
            });
        }
    };

    useEffectWithErrorLogging(() => {
        setAxiosSource(axios.CancelToken.source());
        if (!(overrideReasons && overrideReasons.length > 0)) {
            dispatch(getDropdownOptionsRequest('priceoverridereasons'));
        }

        return () => {
            dispatch(
                storeUsageDataPresist({
                    name: 'showReportPayment',
                    value: false,
                })
            );
            dispatch(
                storeUsageDataPresist({
                    name: 'reportPayment',
                    value: [],
                })
            );
            dispatch({ type: SET_ITEMS_DURING_PRICING, payload: [] });
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
        };
    }, []);

    useEffectWithErrorLogging(() => {
        if (isPriceOverride && priceOverrideTableData.length > 0) {
            setFooterButtonStatuses(
                footerButtonStatuses.map((x) =>
                    x.btnName !==
                        t('consignmentReturn.surgery.notifications.cancel') &&
                    x.btnVisibility
                        ? {
                              ...x,
                              isBtnDisable: isPriceOverrideApplyBtnDisabled(
                                  priceOverrideReason,
                                  priceOverrideTableData,
                                  pricingNotes,
                                  priceOverrideReasonMandatoryUsage,  
                                  priceOverrideReasonVisibilityUsage ,                              
                                  priceOverrideCommentsMandatoryUsage,
                                  priceOverrideCommentsVisibilityUsage
                              ),
                          }
                        : x
                )
            );
            setRPPriceOverrideData(priceOverrideTableData);
        }
    }, [priceOverrideReason, priceOverrideTableData, pricingNotes]);

    const previousAddedVal = (addedProduct) => {
        const ref = useRef();
        useEffectWithErrorLogging(() => {
            ref.current = addedProduct;
        });
        return ref.current;
    };

    const previous = previousAddedVal(addedProduct);

    const updateSelectedProduct = (val, reason) => {
         if(reason === 'clear'){ 
            setOpen(false);
            return;
        } 

        if (reason !== 'clear' && val) {
            if (
                val &&
                val.materialType === 'ZKMT' &&
                checkIfValidBundleItem(val.cfn) &&
                myCaseResourceType !== 'reportPayment'
            ) {
                setOpen(true);
                setBundleError(true);
                setTimeout(() => setBundleError(false), 2000);
                return;
                //setSelectedProduct({ value: val.cfn, isBundle: true });
            } else {
                if (
                    val?.cfn?.toUpperCase().startsWith('S33') &&
                    (!isFeeItemInGatewayOrder(val.cfn, usageDetails) ||
                        isProductCfnInList(val.cfn, reportPaymentGridData))
                ) {
                    setSuccessMessage({
                        show: true,
                        message: invalidSPSitemMsg(),
                    });
                    setTimeout(() => setSuccessMessage(false), 2000);
                    return;
                }
                const isValidBundleItem = val?.cfn
                    ? checkIfValidBundleItem(val.cfn)
                    : false;
                if (isValidBundleItem) {
                    setSelectedProduct({
                        value: val.cfn,
                        salesOrg: val.salesOrg,
                        isBundle: true,
                    });
                    setOpen(true);
                } else {
                    setSelectedProduct({
                        value: val.cfn,
                        salesOrg: val.salesOrg,
                        isBundle: false,
                    });
                    setOpen(true);
                }
                setCheckNewAddedProduct(true);
            }
        }

        if (val) {
            const updatedProductList = [...productsList];
            if (
                !updatedProductList.find((product) => val.cfn === product.cfn)
            ) {
                updatedProductList.push({ ...val, quantity: 1 });
            }
        }
    };

    const handleOnOpen = () => {
        if (addItemSearchItem && typeof addItemSearchItem === 'string' && addItemSearchItem.trim().length >= 3) setOpen(true);
    };

    const onSelectItem = (data) => {
        //Restricting Bundle Item in report payment
        if (
            checkIfValidBundleItem(data?.cfn) &&
            myCaseResourceType !== 'reportPayment'
        ) {
            setBundleError(true);
            setTimeout(() => setBundleError(false), 2000);
            return;
        }
        //checking S33 products
        if (
            data?.cfn?.toUpperCase().startsWith('S33') &&
            (!isFeeItemInGatewayOrder(data.cfn, usageDetails) ||
                isProductCfnInList(data.cfn, reportPaymentGridData))
        ) {
            setSuccessMessage({
                show: true,
                message: invalidSPSitemMsg(),
            });
            setTimeout(() => setSuccessMessage(false), 2000);
            return;
        }
        setSelectedProduct(data.cfn);
    };

    const checkIfValidBundleItem = useCallback(
        (itemId) => {
            if (itemId && bundleHeadersArr && bundleHeadersArr.length > 0) {
                const itemCFN = itemId.toUpperCase();
                return bundleHeadersArr.includes(itemCFN);
            }
            return false;
        },
        [usageDetails, addedProduct, selectedProduct]
    );

    const priceOverrideResetAllClickHandler = () => {
        const inputElements =
            document.getElementsByClassName('adjustedPriceInput');

        for (const element of inputElements) element.value = '';

        setPriceOverrideReason('');
        setPricingNotes('');
        setPriceOverrideTableData(
            priceOverrideTableData.map((item) => ({
                ...item,
                adjustedOtherQtyPrice: null,
                adjustedUsedQtyPrice: null,
                adjustedExtPrice: null,
                invalidOtherQtyAdjBasePriceMsg: null,
                invalidUsedQtyAdjBasePriceMsg: null,
                adjustedOtherQtyExtPrice: null,
                adjustedUsedQtyExtPrice: null,
                overrideUnitPrice: undefined,
                overridenUnitPriceApplied: false,
                overrideUnitPriceApplied: false,
                isPriceOverrideApplied: false,
            }))
        );
        setFooterButtonStatuses(
            footerButtonStatuses.map((x) =>
                x.btnName !==
                    t('consignmentReturn.surgery.notifications.cancel') &&
                x.btnVisibility
                    ? { ...x, isBtnDisable: false }
                    : x
            )
        );
    };

    const getAddedItem = (e, isScanner = false) => {
        if (isScanner) {
            let scanItemCFN = e?.productDetails?.cfn;
            let scanItemdataGTIN = e?.GTIN;
            setAddedProduct({
                value: scanItemCFN,
                isBundle: false,
                isSet: false,
                scannedGTIN: scanItemdataGTIN,
                barcodeData: e,
                isFromBundleItemScanner: false,
                
            });
            dispatch(resetBarcodeDetails());
        }
        setBundleError(false);
        if (e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 9) {
            const addedCfn = e.target.value.trim();
            if (addedCfn.toUpperCase().startsWith('SPS')) {
                setAddedProduct({
                    value: addedCfn,
                    isBundle: false,
                    isSet: true,
                    isFromAddItem: true,
                });
                setCheckNewAddedProduct(true);
            }
            if (
                myCaseResourceType !== 'reportPayment' &&
                bundleHeadersArr?.includes(addedCfn.toUpperCase()) &&
                (addedCfn.toUpperCase().startsWith('M2') ||
                    addedCfn.toUpperCase().startsWith('BUN') ||
                    addedCfn.toUpperCase().startsWith('KEN') ||
                    addedCfn.toUpperCase().startsWith('M1'))
            ) {
                setAddedProduct({});
                setBundleError(true);
                setCheckNewAddedProduct(true);
            } else {
                if (
                    addedCfn.toUpperCase().startsWith('S33') &&
                    (!isFeeItemInGatewayOrder(addedCfn, usageDetails) ||
                        isProductCfnInList(
                            addedCfn,
                            reportPaymentGridData
                        ))
                ) {
                    setSuccessMessage({
                        show: true,
                        message: invalidSPSitemMsg(),
                    });
                    setTimeout(() => setSuccessMessage(false), 2000);
                    return;
                }
                const isValidBundleItem = checkIfValidBundleItem(addedCfn);
                if (isValidBundleItem) {
                    setAddedProduct({
                        value: addedCfn,
                        isBundle: true,
                        isSet: false,
                        isFromAddItem: true,
                    });
                } else {
                    setAddedProduct({
                        value: addedCfn,
                        isBundle: false,
                        isSet: false,
                        isFromAddItem:true,
                    });
                }

                setCheckNewAddedProduct(true);
            }
        }
    };

    useEffectWithErrorLogging(() => {
        if (addedProduct?.value?.length > 0) {
            // SetIsFromReportScreen(true)
            showMessage(addedProduct);
        }
        // else
        // SetIsFromReportScreen(false)
    }, [addedProduct]);

    useEffectWithErrorLogging(() => {
        if (selectedProduct?.value?.length > 0) {
            // SetIsFromReportScreen(true)
            showMessage(selectedProduct);
        }
        // else
        // SetIsFromReportScreen(false)
    }, [selectedProduct]);

    const showMessage = (addedProduct) => {
        //checking addedProduct State is updated or not.
        if (previous != addedProduct.value) {
            if (addedProduct.isBundle) {
                setSuccessMessage({
                    show: true,
                    message: t(
                        'reportUsage.procedure.unidSurgery.SurgeryOrReport.Bundleabove'
                    ),
                });
            } else {
                setSuccessMessage({
                    show: true,
                    message: t(
                        'reportUsage.procedure.unidSurgery.SurgeryOrReport.Itemlistabove'
                    ),
                });
            }
            setTimeout(() => setSuccessMessage(false), 2000);
        }
    };

    const messageCamera = useSelector(
        (state) => state.BarCodeScannerReducer.succesMessageCamera
    );

    useEffectWithErrorLogging(() => {
        if (messageCamera) {
            setSuccessMessage({
                show: true,
                message: t('ConsignmentAdd.common.itemsAdded'),
            });
            setTimeout(() => setSuccessMessage(false), 2000);
        }
        dispatch(successMessageCamera(false));
    }, [messageCamera]);

    const autoCompleteInputChange = (e, value, reason) => {
        if(value){
        if (reason !== 'reset' && reason !== 'clear')
            if (value?.length >= 3 && reason !== 'reset') {
                //setSelectedProduct(value);
                setAddItemSearchItem(value);
                setOpen(true);
                dispatch(
                    searchProducts({
                        searchParam: 'productNumber',
                        searchTerm: value,
                        orderType: 'ZLB',
                        cancelSearchToken: axiosSource.token,
                        usageTerritoryId: usageDetails?.territoryId,
                    })
                );
            } else if (value.length < 3) {
                setAddItemSearchItem(value);
            }
        }
        else if (reason === 'clear' || (reason === 'input' && value === '')) {
            setOpen(false);
            cancelSearchRequest();
            setAddItemSearchItem('');
        }

    };
    const closeAddPoPopup = () => {
        setShowPopup(false);
    };
    const handlePoApply = (updatedObject) => {
        setShowPopup(false);
        onPoApplyClick(updatedObject);
    };

    useEffectWithErrorLogging(() => {
        if (Array.isArray(reportPaymentGridData)) {
            setSelectedCheckBox(
                reportPaymentGridData.filter(
                    (item) => item.isSelected && item.salesOrg != ''
                )
            );

            if (
                myCaseResourceType === 'reportPayment'
                    ? reportPaymentScreenName != 'Review'
                    : true
            ) {
                let isValid =
                    validateReportPaymentItem(
                        reportPaymentGridData,
                        myCaseResourceType === 'reportPayment' ? true : false
                    ) &&
                    (isPricingDone
                        ? reportPaymentGridData?.length > 0 && 
                          reportPaymentGridData.every(
                              (item) =>
                                (!item.isBatchRequired ||
                                    item.lotSerialUnknown ||
                                    !!String(item.lotSerialNumber || '').trim() ||
                                    (item.lotSerial?.length > 0 &&
                                        item.lotSerial.every(
                                            (lot) => lot.lotSerialUnknown ||
                                                !!String(lot.Serial || '').trim()
                                        ))) &&
                                  !item.isInvalidItemMsg &&
                                  ((parseInt(item.usedQuantity) > 0 ||
                                      parseInt(item.otherQuantity) > 0 ||
                                      item.usedQuantity === true ||
                                      item.otherQuantity === true) ||
                                  // Also check lotSerial array for valid quantities
                                  (item.lotSerial && item.lotSerial.length > 0 &&
                                      item.lotSerial.some((ls) => {
                                          const usedVal = ls.used !== undefined ? ls.used : ls.usedQuantity;
                                          const otherVal = ls.other !== undefined ? ls.other : ls.otherQuantity;
                                          return (usedVal && (parseInt(usedVal) > 0 || usedVal === true)) ||
                                                 (otherVal && (parseInt(otherVal) > 0 || otherVal === true));
                                      }))) &&
                                  (item.isBundleItem
                                      ? item.bundleItem?.length > 0 &&
                                        item.bundleItem.every(
                                            (child) => !child.isInvalidItemMsg
                                        ) &&
                                        !item.noItemInBundleErr
                                      : true)
                          )
                        : checkIfValidPricedRPItems(
                              reportPaymentGridData,
                              false,
                              true
                          ));
                if (isValid && myCaseResourceType === 'reportPayment') {
                    if (!rpInitialLoad) {
                        let isNewItemAdded = reportPaymentGridData.filter(
                            (filterItem) => filterItem.isAdditionalCartEntry
                        );
                        const isPriceOverrideApplied =
                            reportPaymentGridData.some(
                                (item) => item.isPriceUpdated
                            );
                        if (
                            isNewItemAdded.length < 1 &&
                            !isPriceOverrideApplied
                        ) {
                            const isPaymentAvaiable =
                                reportPaymentGridData.some(
                                    (item) =>
                                        item.payment &&
                                        Object.keys(item.payment).length >= 1 &&
                                        (item.isDeleteButtonPresent ||
                                            item.isAdditionalCartEntry)
                                );
                            isValid = isPaymentAvaiable;
                        }
                    }
                }

                let filterProductItem = reportPaymentGridData.filter((item) => {
                    let temp =
                        myCaseResourceType === 'reportPayment'
                            ? item.isDeleteButtonPresent ||
                              item.isAdditionalCartEntry
                            : true;
                    let condition =
                        item.salesOrg &&
                        item.salesOrg != '' &&
                        item.unitPrice &&
                        temp;
                    return condition;
                });
                const isAllSelected = filterProductItem.every(
                    (product) => product.isSelected
                );
                setAllSelected(
                    filterProductItem.length >= 1 ? isAllSelected : false
                );
                let submitBtnStatus = footerButtonStatuses.map((x) =>
                    x.btnName !== t('calendar.orders.orderListView.cancel') &&
                    x.btnName !== t('reportUsage.saveExit')
                        ? {
                              ...x,
                              btnVisibility: !isValid
                                  ? myCaseResourceType === 'reportPayment'
                                      ? x.btnName === t('equity.surgery.next')
                                      : countryCode !== COUNTRY_CODE_JAPN
                                      ? x.btnName ===
                                        t(
                                            'reportUsage.reportUsageFooterbuttons.reviewButton'
                                        )
                                      : x.btnName ===
                                        t(
                                            'reportUsage.reportUsageFooterbuttons.replenishButton'
                                        )
                                  : x.btnVisibility,
                              isBtnDisable: (
                                  myCaseResourceType === 'reportPayment'
                                      ? x.btnName === t('equity.surgery.next')
                                      : countryCode !== COUNTRY_CODE_JAPN
                                      ? x.btnName ===
                                        t(
                                            'reportUsage.reportUsageFooterbuttons.reviewButton'
                                        )
                                      : x.btnName ===
                                        t(
                                            'reportUsage.reportUsageFooterbuttons.replenishButton'
                                        )
                              )
                                  ? !isValid
                                  : x.isBtnDisable,
                          }
                        : x
                );
                let saveExitBtn = submitBtnStatus.map((x) =>
                    x.btnName !== t('calendar.orders.orderListView.cancel') &&
                    x.btnName === saveAndExit &&
                    x.btnVisibility
                        ? {
                              ...x,
                              isBtnDisable: toggleSaveExitButton(
                                  reportPaymentGridData,
                                  false
                              ),
                          }
                        : x
                );
                setFooterButtonStatuses(saveExitBtn);
            }
            if (myCaseResourceType === 'reportPayment') {
                dispatch(
                    storeUsageDataPresist({
                        name: 'reportPayment',
                        value: reportPaymentGridData.filter(
                            (item) =>
                                !(item.isAccountOwned || item.accountOwned)
                        ),
                    })
                );
                dispatch(
                    storeUsageDataPresist({
                        name: 'submitButtonInitial',
                        value: rpInitialLoad,
                    })
                );
            }
        }
    }, [
        reportPaymentGridData,
        addedChildProduct,
        selectedChildProduct,
        reportPaymentFlag,
        setIsReportPaymentScreen,
    ]);

    const [poTitle, handlePOTitle] = useState([]);
    const [, setSumTotal] = useState(0);
    let sumValue = 0;

    const handlePoPrice = (ele) => {
        if (
            ele.usedQuantity !== undefined &&
            ele.usedQuantity !== '' &&
            !ele.basePrice
        ) {
            if (
                ele.overrideUnitPrice !== undefined &&
                ele.overrideUnitPrice !== null
            ) {
                return (
                    Number(ele.usedQuantity) *
                    getPriceInNumberDataType(ele.overrideUnitPrice)
                );
            } else {
                return (
                    Number(ele.usedQuantity) *
                    getPriceInNumberDataType(ele.unitPrice)
                );
            }
        } else if (
            ele.otherQuantity !== undefined &&
            ele.otherQuantity !== ''
        ) {
            if (
                ele.overrideUnitPrice !== undefined &&
                ele.overrideUnitPrice !== null
            ) {
                return (
                    Number(ele.otherQuantity) *
                    getPriceInNumberDataType(ele.overrideUnitPrice)
                );
            } else {
                return (
                    Number(ele.otherQuantity) *
                    getPriceInNumberDataType(ele.unitPrice)
                );
            }
        } else if (
            ele.basePrice !== undefined &&
            ele.usedQuantity !== undefined &&
            ele.usedQuantity !== ''
        ) {
            // const val = ele.basePrice.substring(1);
            if (
                ele.overrideUnitPrice !== undefined &&
                ele.overrideUnitPrice !== null
            ) {
                return (
                    Number(ele.usedQuantity) *
                    getPriceInNumberDataType(ele.overrideUnitPrice)
                );
            } else {
                return (
                    Number(ele.usedQuantity) *
                    getPriceInNumberDataType(ele.unitPrice)
                );
            }

            // if (ele.salesOrg === 'S030') {
            //     return (
            //         (ele.usedQuantity ? 1 : 0) *
            //         parseFloat(ele.basePrice.substring(1).replace(/,/g, ''))
            //     );
            // } else {
            //     return ele.usedQuantity * parseFloat(val.replace(/,/g, ''));
            // }
        } else {
            return 0;
        }
    };

    let titleArr;
    useEffectWithErrorLogging(() => {
        let filterTitleArr = [];
        titleArr = reportPaymentGridData.map((ele) => {
            if (ele.payment) {
                return {
                    poNumber: ele.payment.poNumber,
                    amount: handlePoPrice(ele),
                };
            } else {
                return;
            }
        });
        if (titleArr.length >= 1) {
            filterTitleArr = titleArr
                .filter((item) => item?.poNumber)
                .reduce(function (accumulator, cur) {
                    var poNumber = cur.poNumber,
                        found = accumulator.find(function (elem) {
                            return elem.poNumber == poNumber;
                        });
                    if (found) found.amount += cur.amount;
                    else accumulator.push(cur);
                    return accumulator;
                }, []);
        }

        handlePOTitle(filterTitleArr);
    }, [reportPaymentGridData]);
    useEffectWithErrorLogging(() => {
        reportPaymentGridData.forEach((elem) => {
            if (
                (!elem.payment ||
                    (elem.payment &&
                        Object.keys(elem.payment).length === 0 &&
                        Object.getPrototypeOf(elem.payment) ===
                            Object.prototype)) &&
                elem.unitPrice !== undefined
            ) {
                if (
                    elem.usedQuantity !== undefined &&
                    elem.usedQuantity !== null &&
                    elem.usedQuantity != '' &&
                    !elem.basePrice
                ) {
                    if (
                        elem.overrideUnitPrice !== undefined &&
                        elem.overrideUnitPrice !== null
                    ) {
                        sumValue =
                            sumValue +
                            Number(elem.usedQuantity) *
                                getPriceInNumberDataType(
                                    elem.overrideUnitPrice
                                );
                    } else {
                        sumValue =
                            sumValue +
                            Number(elem.usedQuantity) *
                                getPriceInNumberDataType(elem.unitPrice);
                    }
                }
                if (
                    elem.otherQuantity !== undefined &&
                    elem.otherQuantity !== null &&
                    elem.usedQuantity != '' &&
                    !elem.basePrice
                ) {
                    if (
                        elem.overrideUnitPrice !== undefined &&
                        elem.overrideUnitPrice !== null
                    ) {
                        sumValue =
                            sumValue +
                            Number(elem.otherQuantity) *
                                getPriceInNumberDataType(
                                    elem.overrideUnitPrice
                                );
                    } else {
                        sumValue =
                            sumValue +
                            Number(elem.otherQuantity) *
                                getPriceInNumberDataType(elem.unitPrice);
                    }
                }
                if (
                    elem.basePrice !== undefined &&
                    elem.usedQuantity !== undefined &&
                    elem.usedQuantity !== ''
                ) {
                    const baseVal = getPriceInNumberDataType(elem.basePrice);
                    if (elem.salesOrg === 'S030' || displayCheckbox(elem)) {
                        sumValue =
                            sumValue + (elem.usedQuantity ? 1 : 0) * baseVal;
                    } else {
                        sumValue = sumValue + elem.usedQuantity * baseVal;
                    }
                }
                setSumTotal(sumValue);
            } else {
                setSumTotal(sumValue);
            }
        });
    }, [reportPaymentGridData]);
    const handleSumTotal = () => {
        let sumTotalVal = 0;
        reportPaymentGridData.forEach((val) => {
            if (
                val.usedQuantity !== undefined &&
                val.usedQuantity !== null &&
                !val.basePrice &&
                val.unitPrice !== undefined
            ) {
                if (
                    val.overrideUnitPrice !== undefined &&
                    val.overrideUnitPrice !== null
                ) {
                    sumTotalVal =
                        sumTotalVal +
                        Number(val.usedQuantity) *
                            getPriceInNumberDataType(val.overrideUnitPrice);
                } else {
                    sumTotalVal =
                        sumTotalVal +
                        Number(val.usedQuantity) *
                            getPriceInNumberDataType(val.unitPrice);
                }
            } else if (
                val.otherQuantity !== undefined &&
                val.otherQuantity !== null &&
                !val.basePrice
            ) {
                if (
                    val.overrideUnitPrice !== undefined &&
                    val.overrideUnitPrice !== null
                ) {
                    sumTotalVal =
                        sumTotalVal +
                        Number(val.otherQuantity) *
                            getPriceInNumberDataType(val.overrideUnitPrice);
                } else {
                    sumTotalVal =
                        sumTotalVal +
                        Number(val.otherQuantity) *
                            getPriceInNumberDataType(val.unitPrice);
                }
            } else if (
                val.basePrice !== undefined &&
                val.usedQuantity !== undefined &&
                val.usedQuantity !== ''
            ) {
                const baseVal = getPriceInNumberDataType(val.basePrice);
                if (
                    val.overrideUnitPrice !== undefined &&
                    val.overrideUnitPrice !== null
                ) {
                    sumTotalVal =
                        sumTotalVal +
                        Number(val.usedQuantity) *
                            getPriceInNumberDataType(val.overrideUnitPrice);
                } else {
                    sumTotalVal =
                        sumTotalVal + Number(val.usedQuantity) * baseVal;
                }
            } else if (
                val.basePrice !== undefined &&
                val.otherQuantity !== undefined &&
                val.otherQuantity !== ''
            ) {
                const baseVal = getPriceInNumberDataType(val.basePrice);
                if (
                    val.overrideUnitPrice !== undefined &&
                    val.overrideUnitPrice !== null
                ) {
                    sumTotalVal =
                        sumTotalVal +
                        Number(val.otherQuantity) *
                            getPriceInNumberDataType(val.overrideUnitPrice);
                } else {
                    sumTotalVal =
                        sumTotalVal + Number(val.otherQuantity) * baseVal;
                }
            }
        });
        return parseFloat(sumTotalVal);
    };
    const handleDelete = (itemIndex, lotSerialItemIdx, bundleIndex, item,lotItem) => {
        const selectedItem = item || (bundleIndex != undefined
            ? reportPaymentGridData?.[bundleIndex]?.bundleItem?.[itemIndex]
            : reportPaymentGridData?.[itemIndex]);
        const data = {
            itemIndex,
            lotSerialItemIdx,
            bundleIndex,
            item: selectedItem,
            lotItem,
        };
        setProductDeleteWarning(true);
        setDeleteItemDetails(data);
    };

    const resetSelectedOrAddedItem = () => {
        setSelectedProduct({});
        setAddedProduct({});
        setSelectedChildProduct('');
        setAddedChildProduct('');
    };
    return (
        <>
            {isRPPriceOverride ? (
                <PriceOverride
                    priceOverrideTableData={priceOverrideTableData}
                    setPriceOverrideTableData={setPriceOverrideTableData}
                    resetAllClickHandler={priceOverrideResetAllClickHandler}
                    priceOverrideReason={priceOverrideReason}
                    setPriceOverrideReason={setPriceOverrideReason}
                    priceOverrideReasonsList={overrideReasons}
                    itemTableData={[]}
                    isReportPayment={true}
                    pricingNotes={pricingNotes}
                    setPricingNotes={setPricingNotes}
                />
            ) : reportPaymentScreenName === 'Replenish' ? (
                <ReplenViewContainer
                    id={'reportUsage-reportpayment-replen-view-container-report-payment'}
                    onClose={() => {
                        try {
                        setShipAddress(false);
                        dispatch(clearValidateReplenData());
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    shipAddress={shipAddress}
                    setShipAddress={setShipAddress}
                    replenGridData={replenRPGridData}
                    setReplenGridData={setReplenRPGridData}
                    disableApplyShipToButton={replenRPGridData?.some(
                        (item) => item.isInvalidReplenQty
                    )}
                    isReportPayment={true}
                    navigateToSpecifiedScreen={navigateToSpecifiedRPScreen}
                    showReportPayment={showReportPayment}
                />
            ) : reportPaymentScreenName === 'Review' ? (
                <ReviewContainer
                    navigateToSpecifiedScreen={navigateToSpecifiedRPScreen}
                    replenGridData={replenRPGridData.filter(
                        (item) =>
                            !item.accountOwned &&
                            item.shippingDetails &&
                            Object.keys(item.shippingDetails).length > 0
                    )}
                    priceOverrideReason={priceOverrideReason}
                    isReportPayment={true}
                    reportPaymentGridData={reportPaymentGridData}
                    poTitle={poTitle}
                    handlePOTitle={handlePOTitle}
                    handleSumTotal={handleSumTotal}
                    displayPrice={toggleHidePricesBtn === 'hideBtn'}
                    setViewSurgeryNotes={setViewSurgeryNotes}
                />
            ) : (
                !(
                    usageOrderSubmission &&
                    (usageOrderSubmission?.statusCode ||
                        usageOrderSubmission?.errorCode) &&
                    usageOrderSubmission?.clickedBtn ===
                        t('noUsageToReport.submitButton')
                ) && (
                    <>
                        {countryCode !== COUNTRY_CODE_JAPN && (
                            <PatientInformation
                                fromReportPayment={true}
                                title={t('common.patientDetails')}
                            />
                        )}
                        {reportPaymentGridData?.length > 0 &&
                            reportPaymentGridData.some(
                                (item) =>
                                    item.isPriceNotAvailable ||
                                    item.exclusionStatus === noPriceErrorMsg
                            ) && (
                                <ErrorMsgContainer padding={'15px 0'}>
                                    <AlertMsg
                                        message={t(
                                            'productValidationMessages.noPriceErrorMsg'
                                        )}
                                    />
                                </ErrorMsgContainer>
                            )}
                        <AddPoButton
                            onOpenModal={onOpenModal}
                            enablePObutton={enablePObutton}
                            removeAllPo={removeAllPo}
                            showRemovePOText={showRemovePOText}
                        />
                        <ReportPaymentDesktop
                            reportPaymentGridData={reportPaymentGridData}
                            setReportPaymentGridData={setReportPaymentGridData}
                            headerReportPaymentCheckboxClickHandler={
                                headerReportPaymentCheckboxClickHandler
                            }
                            allSelected={allSelected}
                            setAllSelected={setAllSelected}
                            winWidth={winWidth}
                        />

                        <ItemListRPView
                            addedChildProduct={addedChildProduct}
                            setAddedChildProduct={setAddedChildProduct}
                            selectedChildProduct={selectedChildProduct}
                            setSelectedChildProduct={setSelectedChildProduct}
                            selectedProduct={selectedProduct}
                            addedProduct={addedProduct}
                            setShowHidePricesBtn={setShowHidePricesBtn}
                            toggleHidePricesBtn={toggleHidePricesBtn}
                            setToggleHidePricesBtn={setToggleHidePricesBtn}
                            isFromReportScreen={true}
                            filteredProduct={filteredProduct}
                            setFilteredProduct={setFilteredProduct}
                            checkNewAddedProduct={checkNewAddedProduct}
                            reportPaymentGridData={reportPaymentGridData}
                            setReportPaymentGridData={setReportPaymentGridData}
                            checkboxReportPaymentClickHandler={
                                checkboxReportPaymentClickHandler
                            }
                            selectedCheckBox={selectedCheckBox}
                            checkBoxSelectedIndex={checkBoxSelectedIndex}
                            deletePO={deletePO}
                            deleteItem={handleDelete}
                            rpInitialLoad={rpInitialLoad}
                            setRpInitialLoad={setRpInitialLoad}
                            vendorCaseErrorRedirection={
                                vendorCaseErrorRedirection
                            }
                            resetSelectedOrAddedItem={resetSelectedOrAddedItem}
                            setAddedProduct={setAddedProduct}
                            showBundlefromTableList={showBundlefromTableList}
                        />

                        {reportPaymentGridData?.length > 0 && (
                            <PriceItemButton
                                toggleHidePricesBtn={toggleHidePricesBtn}
                                setToggleHidePricesBtn={setToggleHidePricesBtn}
                                showHidePricesBtn={showHidePricesBtn}
                                reportPaymentTable={true}
                                onOpenModal={onOpenModal}
                                enablePObutton={enablePObutton}
                                removeAllPo={removeAllPo}
                                tableData={[...reportPaymentGridData]}
                                showRemovePOText={showRemovePOText}
                                marginTop={'0px'}
                                setIsRPButtonDisabled={setIsButtonDisabled}
                                myCaseResourceType={myCaseResourceType}
                                setReportPaymentGridData={
                                    setReportPaymentGridData
                                }
                                showReportPayment={showReportPayment}
                                priceOverrideReportUsageVisibility={
                                    priceOverrideReportUsageVisibility
                                }
                            />
                        )}
                        {myCaseResourceType === 'reportPayment' &&
                        reportPaymentGridData?.length > 0 &&
                        countryCode === COUNTRY_CODE_JAPN &&
                        priceOverrideReportUsageVisibility === 'NOT_VISIBLE' ? (
                            <PriceOverrideButtonContainer
                                show={false}
                            ></PriceOverrideButtonContainer>
                        ) : (
                            myCaseResourceType === 'reportPayment' && priceOverrideReportUsageVisibility !==
                                'NOT_VISIBLE' && (
                                <PriceOverrideButtonContainer
                                    margin={'0 0 12px 0'}
                                    btnDisabled={isButtonDisabled}
                                    priceOverrideClickHandler={
                                        priceOverrideClickHandler
                                    }
                                    show={true}
                                    priceOverrideReason={priceOverrideReason}
                                    isReportPayment={
                                        myCaseResourceType === 'reportPayment'
                                    }
                                />
                            )
                        )}
                        <AddAndSearchItemContainer
                            isFromReportScreen={true}
                            padding={'5px !important'}
                            marginLeft={'none'}
                            marginLeftInput={'none'}
                        >
                            <AddItemSearchItem
                                id={'reportUsage-reportpayment'}
                                // addItemSearchItem={addItemSearchItem}
                                addItemSearchTerm={addItemSearchItem}
                                checkLotSerial={true}
                                buttonList={localData().searchAddButton}
                                onSearchAddPress={onSearchAddPress}
                                isSelected={isSelected}
                                addItemPlaceholder={t(
                                    'reportUsage.addItems.enterCfnOrItemNumber'
                                )}
                                autoCompleteData={productsList}
                                autoCompleteDataLoading={productListLoading}
                                optionValue={optionValue}
                                autoCompletePlaceholder={t(
                                    'reportUsage.searchItems.searchByItemNameorNumber'
                                )}
                                autoCompleteInputChange={(e, value, reason) =>
                                    autoCompleteInputChange(e, value, reason)
                                }
                                onClose={() => {
                                    try {
                                    setOpen(false);
                                    cancelSearchRequest();
                                     } catch (error) {
                                         logErrorToConsole(error);
                                 }
                                }}
                                setOpen={setOpen}
                                onChange={(_event, newTeam) =>
                                    updateSelectedProduct(_event, newTeam)
                                }
                                handleOnOpen={handleOnOpen}
                                open={
                                    open &&
                                    typeof addItemSearchItem === 'string' &&
                                    addItemSearchItem.trim().length >= 3
                                }
                                onSelectItem={onSelectItem}
                                addItemChange={getAddedItem}
                                succesMessage={successMessage}
                                setSuccesMesssage={setSuccessMessage}
                                bundleError={bundleError}
                                setBundleError={setBundleError}
                                optionLabelKey={''}
                                fontSize={'14px'}
                                fontFamily={'AvenirNextWorld Regular'}
                                color={'#040404'}
                                opacity={'0.9'}
                                placeholderMarginLeft={'-6px'}
                                isReportPayment={true}
                                reportPaymentGridData={reportPaymentGridData}
                                setReportPaymentGridData={
                                    setReportPaymentGridData
                                }
                                filteredProduct={filteredProduct}
                                setFilteredProduct={setFilteredProduct}
                            />

                            {/* <Button
                    show={true}
                    primary={true}
                    height={'38px'}
                    clicked={onOpenModal}
                    margin={'5px'}
                    fontSize={'13px'}
                >
                    {t('reportUsage.addPo')}
                </Button> */}
                            {showPopup && (
                                <AddPo
                                    selectedProduct={selectedCheckBox}
                                    handleClose={closeAddPoPopup}
                                    handleApply={handlePoApply}
                                    onFlagChange={onFlagChange}
                                />
                            )}
                        </AddAndSearchItemContainer>

                        <Summary
                            isFromReportPaymentScreen={true}
                            isLegacyMobile={true}
                            margin={
                                winWidth <= sizes.mobileDevice
                                    ? '0px 24px 4px 19px'
                                    : '0px 33px 4px 19px'
                            }
                            mbHeaderFontSize={'16px'}
                            marginLeft={'10px'}
                            poTitle={poTitle}
                            // sumTotal={sumTotal}
                            // setSumTotal={setSumTotal}
                            handlePOTitle={handlePOTitle}
                            handleSumTotal={handleSumTotal}
                            displayPrice={toggleHidePricesBtn === 'hideBtn'}
                        />
                        {productDeleteWarning &&
                        (deleteItemDetails?.item?.cfn ||
                            deleteItemDetails?.item?.productCFN)
                            ?.toUpperCase()
                            .startsWith('S33') ? (
                            <CancelAlertPopup
                                id={'reportUsage-reportpayment-dienFeeDelete-cancelAlertPopup'}
                                popupTitle={t('reportUsage.common.dienFeeDelete.title')}
                                isDienFeeItem={true}
                                alertMessage={
                                    <>
                                        {t('reportUsage.common.dienFeeDelete.messagePart1')}
                                        <strong>{deleteItemDetails.item.cfn || deleteItemDetails.item.productCFN}</strong>
                                        {t('reportUsage.common.dienFeeDelete.messagePart2')}
                                        <strong>{t('reportUsage.common.dienFeeDelete.yesLabel')}</strong>
                                        {t('reportUsage.common.dienFeeDelete.messagePart3')}
                                        <strong>{t('reportUsage.common.dienFeeDelete.noLabel')}</strong>
                                        {t('reportUsage.common.dienFeeDelete.messagePart4')}
                                    </>
                                }
                                btn1Label={t('reportUsage.common.dienFeeDelete.noLabel')}
                                btn2Label={t('reportUsage.common.dienFeeDelete.yesLabel')}
                                btn1ClickHandler={() => {
                                    setProductDeleteWarning(false);
                                    setDeleteItemDetails(null);
                                }}
                                btn2ClickHandler={deleteItem}
                                btnCloseClickHandler={() => {
                                    setProductDeleteWarning(false);
                                    setDeleteItemDetails(null);
                                }}
                                cancelBtn
                            />
                        ) : productDeleteWarning ? (
                            <CancelAlertPopup
                            id={'reportUsage-reportpayment-cancelalertpopup-report-payment'}
                                popupTitle={t('equity.unsavedChanges.warning')}
                                alertMessage={t(
                                    'reportUsage.procedure.unidSurgery.SurgeryOrReport.areyou'
                                )}
                                btn1Label={t('settings.settingsPopups.yes')}
                                btn2Label={t('settings.settingsPopups.no')}
                                btn1ClickHandler={deleteItem}
                                btn2ClickHandler={() =>
                                    setProductDeleteWarning(false)
                                }
                            />
                        ) : null}
                        {showBundleModal.show && (
                            <BundleAddItemSearchItem
                                showModal={showBundleModal.show}
                                closeBundle={closeBundle}
                                selectedBundleProduct={showBundleModal}
                                addChildProduct={addChildProduct}
                                searchedChildProduct={searchedChildProduct}
                                filteredProduct={filteredProduct}
                                setFilteredProduct={setFilteredProduct}
                                reportPaymentGridData={reportPaymentGridData}
                                setReportPaymentGridData={
                                    setReportPaymentGridData
                                }
                                isReportPayment={true}
                                addItemSearchItem={addItemSearchItem}
                                setAddItemSearchItem={setAddItemSearchItem}

                            />
                        )}
                    </>
                )
            )}
        </>
    );
};

export default ReportPayment;
